module.exports = __webpack_public_path__ + "static/media/grateful.24b98c69.png";